export default "__VITE_ASSET__C36RZw9u__"